const Common = require("./CommonHelpers");
const {makeExtendedVectorClass, V3} = require("../../../../shared/Vector");

// Diagrams can use a 2D vector class under the name V and a 3D vector class
// under the name V3.

const V = makeExtendedVectorClass(2, {
	label(v, ctx, batex, offset) {
		return Common.label(ctx, batex, v[0], v[1], offset);
	},
});

module.exports = {V, V3};
